import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable, forkJoin } from 'rxjs';

import { CotisationRateService } from '@services/cotisation-rate.service';

import { ConjoncturalParameters } from '@interfaces/conjonctural-parameters';
import { CotisationCodeService } from '@services/cotisation-code.service';
import { UiService } from '@services/ui.service';
import { map } from 'rxjs/operators';
import { WorkerCategoryService } from '@services/worker-category.service';
import { EmployerCategoryService } from '@services/employer-category.service';

@Injectable({
    providedIn: 'root'
})
export class ConjoncturalParametersResolver  {
    constructor(
        private uiSrv: UiService,
        private cotisationCodeSrv: CotisationCodeService,
        private cotisationRateSrv: CotisationRateService,
        private workerCategorySrv: WorkerCategoryService,
        private employerCategorySrv: EmployerCategoryService
    ) { }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<ConjoncturalParameters> {

        this.uiSrv.routeLoadingStateChanged.next(true);
        return forkJoin([
            this.cotisationCodeSrv.get(),
            this.cotisationRateSrv.get(),
            this.employerCategorySrv.get(),
            this.workerCategorySrv.get()
        ]).pipe(
            map(([codes, rates, employerCategories, workerCategories]) => {
                this.uiSrv.routeLoadingStateChanged.next(false);
                const params: ConjoncturalParameters = {
                    cotisationCodes: codes,
                    cotisationRates: {
                        employerCategories,
                        rates,
                        workerCategories
                    }
                }
                return params;
            })
        )
    }
}
